import { ADD_UPDATE_PRODUCT_SCHEME_API_URL } from "../components/Shared/constant";

const AddUpdateProductSchemeAPI = async (accessToken, payload) => {
  try {
    const result = await window.axios.post(
      ADD_UPDATE_PRODUCT_SCHEME_API_URL,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return {
      ...result.data,
      status: result.status,
      success: true,
    };
  } catch (error) {
    return {
      ...(error?.response?.data || { message: "Something went wrong" }),
      status: error?.response?.status || 500,
      success: false,
    };
  }
};

export default AddUpdateProductSchemeAPI;
